import { MissionHubTask } from '@/components/mission-hub/MissionHubTask';
import { DailyMission } from '@/components/mission-hub/missions/DailyMission';
import { TwitterConnect } from '@/components/mission-hub/missions/TwitterConnect';
import { TwitterFollows } from '@/components/mission-hub/missions/TwitterFollows';
import { TwitterLikes } from '@/components/mission-hub/missions/TwitterLikes';
import { appPointsAtom } from '@/state/app';
import { MissionHubTaskV2 } from '@/utils/http/get-mission-tasks';
import { FC } from 'react';
import { useRecoilValue } from 'recoil';

interface MissionProps {
    mission: MissionHubTaskV2;
    signup: () => void;
    refreshPoints: () => void;
}
export const Mission: FC<MissionProps> = ({ mission, signup, refreshPoints }) => {
    const { standingData } = useRecoilValue(appPointsAtom);
    const points = standingData.activities[mission._id]?.points ?? 0;

    const getContent = () => {
        switch (mission._id) {
            case 'DAILY-MISSION':
                return <DailyMission signup={signup} points={points} />;
            case 'TWITTER-MISSION':
                return <TwitterLikes signup={signup} />;
            case 'TWITTER-Connect':
                return (
                    <TwitterConnect mission={mission} points={points} signup={signup} refreshPoints={refreshPoints} />
                );
            case 'TWITTER-FollowClayClanDao':
                return (
                    <TwitterFollows
                        mission={mission}
                        points={points}
                        signup={signup}
                        refreshPoints={refreshPoints}
                        follows={'ClayClanDAO'}
                    />
                );
            case 'TWITTER-FollowClayStack':
                return (
                    <TwitterFollows
                        mission={mission}
                        points={points}
                        signup={signup}
                        refreshPoints={refreshPoints}
                        follows={'ClayStack_HQ'}
                    />
                );
            default:
                // @ts-ignore
                return <MissionHubTask mission={mission} points={points} />;
        }
    };

    return getContent();
};
